/* eslint-disable array-bracket-newline */
/* eslint-disable consistent-return */
/* eslint-disable space-before-function-paren */
const Parser = require('rss-parser');

const parser = new Parser({
    customFields: {
        headers: { origin: 'x-requested-with' },
        /*eslint array-bracket-newline: ["error", "always"]*/
        item: [
            ['media:content', 'media', { keepArray: true }]],
    },
});

const getRssData = async(i, url, streamTitle, streamID) => {
    try {
        //-----DEVELOPMENT-----\\
        const CORS_PROXY = 'https://cors-anywhere.herokuapp.com/';
        //Automatically switches to CORS_PROXY by checking production
        const rssUrl = !production ? CORS_PROXY + url : url;
        const subStreamContent = await parser.parseURL(`${rssUrl}`);
        // const re = / /gi;

        const twitterLink = 'https://twitter.com/axway?lang=en';
        const newSubStreamDiv = `
        <div class="twitter-container">
            <div class="twitter-subheading">
                <h2>Check us out on Twitter</h2>
                <div class="twitter-view-all">
                    <a href="${twitterLink}">
                        Read More Tweets
                    </a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20.84" height="14.897" viewBox="0 0 20.84 14.897">
  <path id="Path_35" data-name="Path 35" d="M43.994,28.411l5.334-5.576V41.906H50.44V22.835l5.334,5.576,1.558-.015-7.048-7.331h-.8L42.435,28.4Z" transform="translate(41.906 -42.435) rotate(90)" fill="#7e71ff"/>
</svg>

                </div>
            </div>
            <div class="twitter-tileList-container">
                <ul class="twitter-tileList"></ul>
            </div>
        </div>`;

        const tileArray = subStreamContent.items
            .filter((entry, i) => {
                return i <= 3;
            })
            .map((entry) => {
                // imgURL contains fix for items without images (undefined) breaking import, items with no image will be assigned a default image

                const today = new Date();
                const createdOn = new Date(entry.pubDate);
                const msInDay = 24 * 60 * 60 * 1000;

                createdOn.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);

                const diff = (Number(today) - Number(createdOn)) / msInDay;
                // notice that the classes being written into the elements below are the
                // same as found on the product by default
                let imgURL;

                if (entry.media) {
                    imgURL = entry.media[0].$.url;
                }
                const newTileHTML = `
                <li class="twitter-tile">
                <div class="img visible"><img src="${
                  imgURL
                    ? imgURL
                    : 'https://content.cdntwrk.com/files/aHViPTcwMjM0JmNtZD1pdGVtZWRpdG9yaW1hZ2UmZmlsZW5hbWU9aXRlbWVkaXRvcmltYWdlXzYyMjlmMDUwYzhjYzUucG5nJnZlcnNpb249MDAwMCZzaWc9ZmM4Y2VhYzMzMzFiZWVkNzkyM2FjYmRlODQzZmQ4ZmU%253D'
                }" alt="${entry.title}"></div>
                    <p class="timestamp">${diff} days ago</p>
                    <div class="description">
                    <h4 class="long-h3">${entry.contentSnippet}</h4>
                    </div>
                    <svg id="Icon_awesome-twitter" data-name="Icon awesome-twitter" xmlns="http://www.w3.org/2000/svg" width="20.537" height="16.68" viewBox="0 0 20.537 16.68">
                    <path id="Icon_awesome-twitter-2" data-name="Icon awesome-twitter" d="M18.426,7.538c.013.182.013.365.013.547A11.893,11.893,0,0,1,6.463,20.061,11.894,11.894,0,0,1,0,18.171a8.707,8.707,0,0,0,1.016.052,8.429,8.429,0,0,0,5.225-1.8,4.216,4.216,0,0,1-3.935-2.919,5.308,5.308,0,0,0,.795.065,4.452,4.452,0,0,0,1.108-.143A4.21,4.21,0,0,1,.834,9.3V9.245a4.239,4.239,0,0,0,1.9.534,4.215,4.215,0,0,1-1.3-5.629,11.964,11.964,0,0,0,8.679,4.4,4.752,4.752,0,0,1-.1-.964,4.213,4.213,0,0,1,7.284-2.88,8.287,8.287,0,0,0,2.671-1.016,4.2,4.2,0,0,1-1.85,2.32,8.438,8.438,0,0,0,2.424-.652,9.048,9.048,0,0,1-2.111,2.176Z" transform="translate(0 -3.381)" fill="#b4b6b8"/>
                    </svg>
                    <a href="${entry.link}"></a>
                </li>`;

                return newTileHTML;
            });

        let tileString = '';
        $.each(tileArray, (i, tile) => {
            tileString += tile;
        });

        const stringSliceNum = newSubStreamDiv.indexOf('</ul>');
        const newEntireSubStream =
            newSubStreamDiv.substring(0, stringSliceNum) +
            tileString +
            newSubStreamDiv.substring(stringSliceNum);
        return newEntireSubStream;
    } catch (error) {
        if (window.location.href === 'https://localhost:3000/') {
            console.warn(
                '%c🤖💬 BeckyBot:',
                'font-size: 12px; color: #fff; padding-top: 2px;',
                'Hey Onbrander! If you want the imported streams to work in this localhost, change the commented-out text in importedStreams.js!'
            );
        }
        console.error(
            "%c🤖💬 There's this error in the getRssData:",
            'font-size: 12px; color: #fff; padding-top: 2px;',
            error,
            '(Onbrand hint: Check to see if the prod CORS_PROXY and subStreamContent is active)'
        );
    }
};

const createSubStream = async(subStreamObject) => {
    const streamTitle = Object.keys(subStreamObject)[0];
    const url = subStreamObject[streamTitle].replace(
        '//localhost:3000',
        'https://resources.axway.com/'
    );
    // const url = subStreamObject[streamTitle];
    const streamID = subStreamObject.streamID;

    const substream = await getRssData(0, url, streamTitle, streamID);

    return substream;
};

// the object that will get passed in as the parameter will be the
// subStream configuration created in the Uberflip App.
const createStreamTemplate = async(obj) => {
    const streamID = Object.keys(obj)[0];

    const stream =
        document.querySelector(`.hub-page`) ||
        document.querySelector(`.listing-page.stream-${streamID}`);
    let twitterFeed = '';

    if (stream) {
        //the array with the appropriate sub-stream gets passed onwards
        stream.classList.add('ob-importedStreams-template');
        twitterFeed = await createSubStream(obj[streamID]);
        return twitterFeed;
    }
};

const twitterRSS = async() => {
    // console.log('this is twitterRSS');
    let twitterConfig;

    if (window.obData) {
        twitterConfig = window.obData.twitterRSS;
    } else {
        return;
    }

    if (twitterConfig) {
        let twitterFeed = '';

        twitterFeed = await createStreamTemplate(twitterConfig);

        const collectionItems = document.querySelector('#collection-items');

        if (collectionItems && twitterFeed) {
            collectionItems.insertAdjacentHTML('beforeend', twitterFeed);
        }
    }
};

module.exports = { twitterRSS };


// WEBPACK FOOTER //
// ./scriptPartials/twitterRSS.js